import * as React from "react";
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Skeleton from "@mui/material/Skeleton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";

function Media(props) {
  const { loading = false } = props;

  return (
    <Card sx={{ m: 2, maxWidth: "1440px", margin: "0 auto" }}>
      <AppBar position="static" color="inherit" elevation={0}>
        <Toolbar className="flex justify-between">
          {/* Left side */}
          <Box className="flex items-center space-x-6">
            {/* Logo skeleton */}
            <Skeleton variant="rectangular" width={240} height={30} />
          </Box>
          <Box className="flex items-center space-x-6">
            {/* Logo skeleton */}

            {/* Nav items */}
            <Skeleton variant="text" width={100} height={30} />
            <Skeleton variant="text" width={80} height={30} />
            <Skeleton variant="text" width={90} height={30} />
            <Skeleton variant="text" width={90} height={30} />
          </Box>

          {/* Right side */}
          <Box className="flex items-center space-x-4">
            <Skeleton variant="circular" width={35} height={35} />
            <Skeleton variant="circular" width={35} height={35} />
            <Skeleton variant="circular" width={40} height={40} />
          </Box>
        </Toolbar>
      </AppBar>
      <Skeleton
        sx={{ height: "90vh" }}
        animation="wave"
        variant="rectangular"
      />

      <CardContent>
        <React.Fragment>
          <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
          <Skeleton animation="wave" height={10} width="80%" />
        </React.Fragment>
      </CardContent>
    </Card>
  );
}

Media.propTypes = {
  loading: PropTypes.bool,
};

export default function Facebook() {
  return (
    <div>
      <Media loading />
    </div>
  );
}
